import { Callout, DataTable, DataTableEmptyRow } from '../../components/ui'
import { dedicatedReportsApi, type RevenueWireRow } from '../../api/dedicatedReports'
import { DedicatedReportShell, Limitations, eur, pct } from './DedicatedReportShell'

function RevenueTable({ first, rows }: { first: string; rows: RevenueWireRow[] }) {
  return (
    <DataTable>
      <thead>
        <tr>
          <th>{first}</th>
          <th className="text-end md-num">Presunto</th>
          <th className="text-end md-num">Maturato</th>
          <th className="text-end md-num">Incassato</th>
        </tr>
      </thead>
      <tbody>
        {rows.map(r => (
          <tr key={r.key}>
            <td>{r.label}</td>
            <td className="text-end md-num">{eur(r.presumed)}</td>
            <td className="text-end md-num">{eur(r.accrued)}</td>
            <td className="text-end md-num">{eur(r.collected)}</td>
          </tr>
        ))}
        {rows.length === 0 && <DataTableEmptyRow colSpan={4} title="Nessun dato nel periodo." />}
      </tbody>
    </DataTable>
  )
}

/** R3-22 — ricavi nei tre stati (presunto, maturato, incassato) per mese, settore e operatore. Solo con la lettura amministrativa. */
export function RevenueReportPage() {
  return (
    <DedicatedReportShell title="Report ricavi" icon="payments" load={dedicatedReportsApi.revenue}>
      {d => !d.money || !d.total ? (
        <Callout tone="info">{d.message ?? 'Gli importi sono visibili solo con la lettura amministrativa.'}</Callout>
      ) : (
        <>
          <div className="text-muted md-typescale-body-small mb-2">
            Dal {d.period.from} al {d.period.to}. Totale: presunto {eur(d.total.presumed)}, maturato {eur(d.total.accrued)}, incassato {eur(d.total.collected)}; tasso d’incasso {pct(d.collectionRate)}.
          </div>
          <RevenueTable first="Mese" rows={(d.byMonth ?? []).map(m => ({ key: m.month, label: m.month, ...m }))} />
          <RevenueTable first="Settore" rows={d.byDepartment ?? []} />
          <RevenueTable first="Operatore" rows={d.byOperator ?? []} />
          <Limitations items={d.limitations} />
        </>
      )}
    </DedicatedReportShell>
  )
}
